module.exports = __webpack_public_path__ + "static/media/plugoRental.4bfba06f.png";